package com.evoapps.evoshift.data.dto.auth

import kotlinx.serialization.Serializable

@Serializable
data class InviteDto(
    // ID dokumentu w Firestore = kod zaproszenia
    val id: String = "",

    val workplaceId: String = "",
    val workplaceName: String = "",

    // Kto zaprasza (do wyświetlenia na ekranie "Jan Kowalski zaprasza Cię...")
    val inviterId: String = "",
    val inviterName: String = "",

    // KLUCZOWE: ID "użytkownika-cienia", którego dane (stawki, grafik)
    // mają zostać przepisane na konto osoby, która kliknie w link.
    val targetShadowUserId: String = "",

    // Rola w systemie (np. EMPLOYEE/MANAGER) - dla bezpieczeństwa
    val permission: String = "EMPLOYEE",

    // Statusy
    val status: InviteStatus = InviteStatus.PENDING,
    val createdAt: String = "",
    val expiresAt: String = "",
    /** Address to e-mail the invitation to (the server sends it); null: code passed on by hand. */
    val email: String? = null,
    /** Language of the invitation e-mail ("pl" | "en"), the inviting manager's. */
    val language: String? = null
)

@Serializable
enum class InviteStatus {
    PENDING,  // Można użyć
    ACCEPTED, // Już wykorzystane
    EXPIRED   // Wygasło
}